import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import moment from "moment";
import '../styles/noPrint.css';

const PreviewReceiptVoucher = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const personId = searchParams.get("personId");
  const navigate = useNavigate();
  const receiptData = location.state?.data;

 const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState({});
  const [rowData, setRowData] = useState(receiptData || {});
  const token = localStorage.getItem("token");
  const centerCode = localStorage.getItem("code");
  const sewadarId = localStorage.getItem('sewadarId');

  const handleMakeFinal = async () => {
    if (!rowData?.items || rowData.items.length === 0) {
      Swal.fire("Error", "No items available to submit", "error");
      return;
    }

    const confirmation = await Swal.fire({
      text: "कृपया सभी जानकारी की पूरी तरह से सत्यापन कर लें, इसके पश्चात किसी भी जानकारी में किसी भी प्रकार का परिवर्तन नहीं किया जाएगा।",
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#f05d5d",
      confirmButtonText: "Yes",
    });

    if (!confirmation.isConfirmed) return;

    setIsSubmitting(true);

    try {
      const payload = {
        voucherId: rowData.id,
        centerCode: centerCode,
        transactionCode:rowData?.documentNo,
        ledgerName:rowData?.ledgerName,
        ledgerId:rowData?.ledgerId,
        rvNo:rowData?.rvNo,
        receiptDate:rowData?.srDate,
        billDate:rowData?.documentDate,
        maintainBalance:rowData?.maintainBalance,
        items: rowData.items.map(item => ({
          itemId: item.itemId,
          itemName:item.itemName,
          receivedQty: item.receivedQty,
          Location: item.departmentName + " : Store", 
          uom: item.uom,
          state: "As Stock", 
          type: "add", 
          particulars: "Receipt Note",
          department: item.departmentName,
          affectedDate:rowData.date
        }))
      };

      const response = await apiClient.post(
        `${SERVER_BASE}/finalize-receipt-voucher`,
        payload,
        {headers: { Authorization: `Bearer ${token}`},
        }
      );

      Swal.fire(
        "Success!",
        "Receipt voucher has been finalized and stock updated",
        "success"
      ).then(() => {
        navigate("../dashboard/ReceiptVoucherList");
      });
    } catch (error) {
      console.error("Error finalizing voucher:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to finalize voucher",
        "error"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchCenterInfo = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
          params: { code: centerCode },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data[0]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchCenterInfo();
  }, []);

  if (!rowData) return <p>No data available. Please go back to the list.</p>;

  const getApprovalSummary = () => {
    const summaryMap = new Map();
    rowData?.items?.forEach((item) => {
      const key = `${item.departmentName}|${item.approvedByName}`;
      if (!summaryMap.has(key)) {
        summaryMap.set(key, {
          departmentName: item.departmentName,
          approvedByName: item.approvedByName,
          approvedAt: item.approvedAt,
          count: 0,
        });
      }
      summaryMap.get(key).count += 1;
    });
    return Array.from(summaryMap.values());
  };

  const approvalSummary = getApprovalSummary();
  const itemDetails = rowData?.items || [];

  return (
    <div
      style={{

        border: "1px solid",
        margin: "15px auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "1100px",
        fontSize: "14px",
      }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button className="btn btn-secondary no-print" onClick={() => window.history.back()}>
          Back
        </button>
        <h3 className="m-0 text-center">Receipt</h3>
        <div className="d-flex gap-2">
         
        {(rowData.receiptStatus == 'Verified' && rowData?.createdBy == sewadarId ) && (
         <button 
            className="btn btn-success no-print"
            onClick={handleMakeFinal}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Processing..." : "Make it Final"}
          </button>
          )}
          {(rowData.receiptStatus == 'Verified' || rowData.receiptStatus == 'Final') && (
         <button 
            className="btn btn-success no-print"
            onClick={()=>window?.print()}
          >
         Print
          </button>
          )}
      </div>
      </div>
      

      {/* Primary Info */}
      <div className="row mt-4" style={{ fontSize: "15px" }}>
        <div className="col-3"><strong>Receipt No:</strong> {rowData?.rvNo}</div>
        <div className="col-3"><strong>Receipt Date:</strong> {rowData?.date ? moment(rowData.date).format("DD-MMMM-YY") : ""}</div>
        <div className="col-5"><strong>Ledger:</strong> {rowData?.ledgerName}</div>
        <div className="col-3"><strong>Document No:</strong> {rowData?.documentNo}</div>
        <div className="col-3"><strong>Document Date:</strong> {rowData?.documentDate ? moment(rowData.documentDate).format("DD-MMMM-YYYY") : ""}</div>
        {rowData?.voucherType!='DR' && (<>
        <div className="col-5">
          <strong>Entry Date & Time:</strong>{" "}
          {rowData?.entryDate ? moment(rowData.entryDate).format("DD-MMM-YYYY") : ""}{" "}
          {rowData?.entryTime ? moment(rowData.entryTime, "HH:mm:ss").format("hh:mm A") : ""}
        </div></>)}
        <div className="col-3"><strong>Purpose:</strong> {rowData?.purposeName}</div>
        <div className="col-3"><strong>On Account:</strong> {rowData?.onAccount}</div>
        {rowData?.onAccount !== "Project" && (
          <div className="col-4"><strong>Inventory:</strong> {rowData?.inventory}</div>
        )}
         {rowData?.voucherType !='DR' && (<>
        <div className="col-3"><strong>Vehicle No:</strong> {rowData?.vehicleNo}</div>
        <div className="col-3"><strong>Driver Name:</strong> {rowData?.driverName}</div>
        <div className="col-3"><strong>Mobile No:</strong> {rowData?.driverMobile}</div>
        </>)}
      </div>

      {/* Item Table */}
      <h6 className="mt-4 mb-2"></h6>
      <table className="table table-bordered" style={{ fontSize: "14px" }}>
        <thead className="table-light">
          <tr>
            <th>S.No</th>
            <th>Department</th>
            <th>Item Description</th>
            <th>Document Qty</th>
            <th>Received Qty</th>
            <th>UOM</th>
            <th>Diff.</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {itemDetails.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.departmentName}</td>
              <td>{item.itemName}</td>
              <td>{Number(item.challanQty) % 1 == 0 ? parseInt(item.challanQty) : parseFloat(item.challanQty).toFixed(2)}</td>
              <td>{Number(item.receivedQty) % 1 == 0 ? parseInt(item.receivedQty) : parseFloat(item.receivedQty).toFixed(2)}</td>
              <td>{item.uom}</td>
              <td>
                {Number(item.difference) == 0
                  ? 0
                  : Number(item.difference) < 0
                  ? `Excess ${Math.abs(item.difference) % 1 == 0
                      ? parseInt(Math.abs(item.difference))
                      : parseFloat(Math.abs(item.difference)).toFixed(2)}`
                  : `Short ${Number(item.difference) % 1 == 0
                      ? parseInt(item.difference)
                      : parseFloat(item.difference).toFixed(2)}`}
              </td>
              <td>{item.remarks}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Approval Summary */}
      <h6 className="mt-3 mb-2 text-center fw-bold">Approval Summary</h6>
      <table className="table table-bordered" style={{ fontSize: "14px" }}>
        <thead className="table-light">
          <tr>
            <th>S.No</th>
            <th>Department</th>
            <th>Approved By</th>
            <th>No. of Items</th>
          </tr>
        </thead>
        <tbody>
          {approvalSummary.map((summary, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{summary.departmentName}</td>
              <td>
                {summary.approvedByName
                  ? `${summary.approvedByName} on ${summary.approvedAt ? moment(summary.approvedAt).format("DD-MMMM-YYYY hh:mm A") : ""}`
                  : ""}
              </td>
              <td>{summary.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between">
      <h6 className="text-danger fw-bold">To Generate Receipt Make it Final is Mandatory</h6>
      <div>
      <p className="text-end mb-4"  style={{ marginBottom:'7px'}}>Radha Soami Satsang Beas</p>
      <p className="text-end" style={{  fontWeight: 'bold' }}>Authorised Signatory</p>
      </div>
      </div>
      {/* Print Styles */}
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
            .footer {
              position: absolute;
              bottom: 0;
              width: 100%;
              page-break-before: always;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PreviewReceiptVoucher;
